export enum UnitsTypes {
    LENGTH = 'LENGTH',
    TIME = 'TIME'
}
